module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_m_albino.67b86146.png";